<template>
  <div :class="['video-block', alignmentClass]">
    <p v-if="heading" class="text-lg text-center text-uppercase">
      {{ heading }}
    </p>

    <div class="video-wrapper">
      <div class="video-container">
        <video
          ref="videoEl"
          v-if="video?.url"
          :poster="previewImage?.url"
          :controls="isPlaying"
          preload="metadata"
          @play="isPlaying = true"
          @pause="isPlaying = false"
        >
          <!-- if there is no previewImage set, media fragment makes the browser paint the frame at 2s as poster -->
          <source :src="previewImage? video.url : video.url + '#t=2'" type="video/mp4" />
        </video>

        <!-- Custom Play Button -->
        <button
          v-if="!isPlaying"
          class="play-button"
          @click="playVideo"
          aria-label="Play video"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40"><circle cx="20" cy="20" r="19.5" fill="#fff" stroke="#212"/><path fill="#212" fill-rule="evenodd" d="m16 27.649 11.145-8.324L16 11" clip-rule="evenodd"/></svg>
        </button>
      </div>

      <p v-if="video?.caption" class="text-sm text-family-secondary pt-2">
        {{ video.caption }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  heading: { type: String, default: null },
  alignment: { type: String, default: 'left' },
  video: { type: Object, required: true },
  previewImage: { type: Object, default: null }
})

const videoEl = ref(null)
const isPlaying = ref(false)

const playVideo = () => {
  // the #t=2 poster leaves the video seeked forward; rewind before playing
  if (videoEl.value) videoEl.value.currentTime = 0
  videoEl.value?.play()
  isPlaying.value = true
}

const alignmentClass = computed(() => {
  if (props.alignment === 'center') return 'col-12 col-sm-6 offset-sm-3'
  if (props.alignment === 'right') return 'col-12 col-sm-6 offset-sm-6'
  return 'col-12 col-sm-6'
})
</script>
